import React, { useEffect, useState, useRef, forwardRef } from 'react';
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl';

import { CONFIG } from '@/config';

import 'mapbox-gl/dist/mapbox-gl.css';

function Map({ node, children, callbacks, minZoom = 3, ...rest }, ref) {
    const ob = useRef(null);
    const [map, setMap] = useState(null);

    useEffect(() => {
        if (!ob.current && node) {
            // `map` is state, so this closure would only ever see its first value.
            ob.current = new ResizeObserver(() => {
                ref.current?.resize();
            });

            ob.current.observe(node);
        }

        return () => {
            ob.current?.disconnect();
            ob.current = null;
        };
    }, [node]);

    useEffect(() => {
        if (node) {
            ref.current = new mapboxgl.Map({
                ...rest,
                container: node,
                style: `mapbox://styles/mapbox/streets-v12`,
                accessToken: CONFIG.MAPBOX_PK,
                minZoom,
            });

            ref.current.on('load', () => {
                callbacks.onLoad(ref.current);
            });

            setMap(ref.current);
        }
    }, [node]);

    return <>{children({ map })}</>;
}

export default forwardRef(Map);
